import React, { useState } from 'react';

const JSONDataComparator = () => {
    const [jsonArray1, setJsonArray1] = useState('');
    const [jsonArray2, setJsonArray2] = useState('');
    const [uniqueInArray1, setUniqueInArray1] = useState([]);
    const [uniqueInArray2, setUniqueInArray2] = useState([]);
    const [commonItems, setCommonItems] = useState([]);
    const [error, setError] = useState('');
    const [copyState, setCopyState] = useState({}); // Track copy state for each section

    const exampleArray1 = `[
        { "id": 1, "name": "Alice" },
        { "id": 2, "name": "Bob" },
        { "id": 3, "name": "Charlie" }
    ]`;

    const exampleArray2 = `[
        { "id": 2, "name": "Bob" },
        { "id": 4, "name": "David" },
        { "id": 3, "name": "Charlie" }
    ]`;

    const compareArrays = () => {
        try {
            const array1 = JSON.parse(jsonArray1);
            const array2 = JSON.parse(jsonArray2);

            if (!Array.isArray(array1) || !Array.isArray(array2)) {
                throw new Error('Both inputs must be valid JSON arrays.');
            }

            const uniqueToArray1 = array1.filter(item => !array2.some(el => JSON.stringify(el) === JSON.stringify(item)));
            const uniqueToArray2 = array2.filter(item => !array1.some(el => JSON.stringify(el) === JSON.stringify(item)));
            const common = array1.filter(item => array2.some(el => JSON.stringify(el) === JSON.stringify(item)));

            setUniqueInArray1(uniqueToArray1);
            setUniqueInArray2(uniqueToArray2);
            setCommonItems(common);
            setError('');
            setCopyState({}); // Reset copy state
        } catch (err) {
            setError(err.message || 'Invalid JSON. Please check your input.');
            setUniqueInArray1([]);
            setUniqueInArray2([]);
            setCommonItems([]);
            setCopyState({});
        }
    };

    const clearInputs = () => {
        setJsonArray1('');
        setJsonArray2('');
        setUniqueInArray1([]);
        setUniqueInArray2([]);
        setCommonItems([]);
        setError('');
        setCopyState({});
    };

    const useExampleData = () => {
        setJsonArray1(exampleArray1);
        setJsonArray2(exampleArray2);
        setUniqueInArray1([]);
        setUniqueInArray2([]);
        setCommonItems([]);
        setError('');
        setCopyState({});
    };

    const handleCopy = (dataKey, data) => {
        navigator.clipboard.writeText(JSON.stringify(data, null, 2));
        setCopyState({ ...copyState, [dataKey]: true });
        setTimeout(() => setCopyState({ ...copyState, [dataKey]: false }), 2000);
    };

    return (
        <div className="container mt-4">
            <div className="text-center mb-3">
                <button className="btn btn-info" onClick={useExampleData}>
                    Use Example Data
                </button>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <textarea
                        className="form-control"
                        rows="10"
                        value={jsonArray1}
                        onChange={(e) => setJsonArray1(e.target.value)}
                        placeholder="Enter first JSON array here..."
                        style={{ border: '2px solid #ccc', borderRadius: '5px' }}
                    />
                </div>
                <div className="col">
                    <textarea
                        className="form-control"
                        rows="10"
                        value={jsonArray2}
                        onChange={(e) => setJsonArray2(e.target.value)}
                        placeholder="Enter second JSON array here..."
                        style={{ border: '2px solid #ccc', borderRadius: '5px' }}
                    />
                </div>
            </div>
            <div className="text-center">
                <button className="btn btn-success me-2" onClick={compareArrays}>
                    Compare Arrays
                </button>
                <button className="btn btn-secondary" onClick={clearInputs}>
                    Clear
                </button>
            </div>
            {error && <p className="text-danger text-center mt-3">{error}</p>}
            {uniqueInArray1.length > 0 && (
                <div className="mt-4">
                    <h5>Unique in Array 1</h5>
                    <pre
                        className="p-3"
                        style={{
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                        }}
                    >
                        {JSON.stringify(uniqueInArray1, null, 2)}
                    </pre>
                    <button
                        className={`btn mt-2 ${copyState['uniqueInArray1'] ? 'btn-success' : 'btn-primary'}`}
                        onClick={() => handleCopy('uniqueInArray1', uniqueInArray1)}
                    >
                        {copyState['uniqueInArray1'] ? 'Copied!' : 'Copy Output'}
                    </button>
                </div>
            )}
            {uniqueInArray2.length > 0 && (
                <div className="mt-4">
                    <h5>Unique in Array 2</h5>
                    <pre
                        className="p-3"
                        style={{
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                        }}
                    >
                        {JSON.stringify(uniqueInArray2, null, 2)}
                    </pre>
                    <button
                        className={`btn mt-2 ${copyState['uniqueInArray2'] ? 'btn-success' : 'btn-primary'}`}
                        onClick={() => handleCopy('uniqueInArray2', uniqueInArray2)}
                    >
                        {copyState['uniqueInArray2'] ? 'Copied!' : 'Copy Output'}
                    </button>
                </div>
            )}
            {commonItems.length > 0 && (
                <div className="mt-4">
                    <h5>Common Items</h5>
                    <pre
                        className="p-3"
                        style={{
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                        }}
                    >
                        {JSON.stringify(commonItems, null, 2)}
                    </pre>
                    <button
                        className={`btn mt-2 ${copyState['commonItems'] ? 'btn-success' : 'btn-primary'}`}
                        onClick={() => handleCopy('commonItems', commonItems)}
                    >
                        {copyState['commonItems'] ? 'Copied!' : 'Copy Output'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default JSONDataComparator;